import AccountYearSelectionScreen from 'features/statementsAndForms/screens/AccountStatements/AccountYearSelectionScreen';
import React from 'react';

export default function AccountYearSelectionScreenPage() {
  return <AccountYearSelectionScreen />;
}
